import React, { createContext, useContext, useState } from "react";
import { ReturnInvoice } from "../types/return";
import {
    getReturns,
    createReturn,
    updateReturn as apiUpdateReturn,
    deleteReturn as apiDeleteReturn,
    getReturn
} from "../api/returnApi";

interface ReturnContextProps {
    returns: ReturnInvoice[];
    data: ReturnInvoice | null;
    addReturn: (data: ReturnInvoice) => Promise<ReturnInvoice>;
    updateReturn: (data: ReturnInvoice) => Promise<void>;
    deleteReturn: (id: string) => Promise<void>;
    fetchReturns: () => Promise<void>;
    fetchReturn: (id: string) => Promise<ReturnInvoice>;
}

const ReturnContext = createContext<ReturnContextProps | undefined>(undefined);

export const ReturnProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [returns, setReturns] = useState<ReturnInvoice[]>([]);
    const [data, setData] = useState<ReturnInvoice | null>(null);
    const fetchReturns = async () => {
        const list = await getReturns();
        setReturns(list.map((r: any) => ({ ...r, id: r._id || r.id })));
    };

    const fetchReturn = async (id: string) => {
        const doc = await getReturn(id);
        setData(doc);
        return doc;;
    };

    const addReturn = async (data: Omit<ReturnInvoice, "id">) => {
        const created = await createReturn(data);
        return created;
    };

    const updateReturn = async (updated: ReturnInvoice) => {
        await apiUpdateReturn(updated.id!, updated);
        await fetchReturns();
    };

    const deleteReturn = async (id: string) => {
        await apiDeleteReturn(id);
        await fetchReturns();
    };

    return (
        <ReturnContext.Provider value={{
            returns,
            data,
            addReturn,
            updateReturn,
            deleteReturn,
            fetchReturns,
            fetchReturn,
        }}>
            {children}
        </ReturnContext.Provider>
    );
};

export const useReturn = () => {
    const ctx = useContext(ReturnContext);
    if (!ctx) throw new Error("useReturn must be inside ReturnProvider");
    return ctx;
};
